/**
 * Licentie e-mail validatie voor Shopify cart
 *
 * Gedrag:
 * - Doet niets als het licentieveld niet in de DOM staat (licentie niet in cart)
 * - Checkout-knop blijft normaal klikbaar — geen verborgen disabled state
 * - Bij klikken zonder geldig e-mail: scroll naar veld + toon foutmelding, checkout geblokkeerd
 * - Foutmelding verdwijnt zodra een geldig adres ingevuld wordt
 * - Onderschept ook dynamische knoppen (PayPal, iDEAL) en form submit via Enter
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const licentieInput = document.getElementById('licentie_email');

    // Niets doen als veld niet aanwezig is (licentie niet in cart)
    if (!licentieInput) return;

    const checkoutButton = document.getElementById('checkout');
    const dynamicButtons = document.querySelector('.cart__dynamic-checkout-buttons');
    const cartForm       = document.getElementById('cart');

    // Foutmelding-element aanmaken direct onder het invoerveld
    const foutmelding = document.createElement('p');
    foutmelding.id = 'licentie-email-fout';
    foutmelding.setAttribute('role', 'alert');
    foutmelding.style.cssText = [
      'color:#c0392b',
      'font-size:1.3rem',
      'margin-top:0.5rem',
      'margin-bottom:0',
      'display:none',
    ].join(';');
    foutmelding.textContent = 'Vul een geldig e-mailadres in voor de licentie activatie.';
    licentieInput.insertAdjacentElement('afterend', foutmelding);

    licentieInput.setAttribute('aria-describedby', 'licentie-email-fout');
    licentieInput.setAttribute('aria-required', 'true');

    // Gebruik ingebouwde browser e-mail validatie
    function isGeldigEmail(waarde) {
      if (waarde.trim() === '') return false;
      const check = document.createElement('input');
      check.type  = 'email';
      check.value = waarde.trim();
      return check.validity.valid;
    }

    function toonFout() {
      foutmelding.style.display = 'block';
      licentieInput.setAttribute('aria-invalid', 'true');
      licentieInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      licentieInput.focus();
    }

    function verbergFout() {
      foutmelding.style.display = 'none';
      licentieInput.removeAttribute('aria-invalid');
    }

    // Foutmelding verbergen zodra geldig adres ingetypt wordt
    licentieInput.addEventListener('input', function () {
      if (isGeldigEmail(licentieInput.value)) {
        verbergFout();
      }
    });

    // Foutmelding tonen als veld verlaten wordt met ongeldig adres
    licentieInput.addEventListener('blur', function () {
      if (licentieInput.value.trim() !== '' && !isGeldigEmail(licentieInput.value)) {
        foutmelding.style.display = 'block';
        licentieInput.setAttribute('aria-invalid', 'true');
      }
    });

    // Checkout-knop: blokkeer en toon fout als e-mail ontbreekt
    if (checkoutButton) {
      checkoutButton.addEventListener('click', function (event) {
        if (!isGeldigEmail(licentieInput.value)) {
          event.preventDefault();
          toonFout();
        }
      });
    }

    // Dynamische knoppen (PayPal, iDEAL etc.) onderscheppen
    if (dynamicButtons) {
      dynamicButtons.addEventListener('click', function (event) {
        if (!isGeldigEmail(licentieInput.value)) {
          event.preventDefault();
          event.stopPropagation();
          toonFout();
        }
      }, true); // capture phase zodat dit vóór de Shopify handlers vuurt
    }

    // Form submit via Enter of andere paden onderscheppen
    if (cartForm) {
      cartForm.addEventListener('submit', function (event) {
        if (!isGeldigEmail(licentieInput.value)) {
          event.preventDefault();
          toonFout();
        }
      });
    }
    // Trigger page reload bij remove, timeout zodat cart eerst bijgewerkt kan worden.
    document.addEventListener('click', function (event) {
    if (event.target.closest('cart-remove-button')) {
    setTimeout(function () {
      window.location.reload();
    }, 500);
    }
});
  });
})();
